import { Comune, ComuniResponse, Provincia } from '@framework/api-client';

export interface IProvinceItem {
  label: string;
  value: string;
  context?: Provincia;
}

export interface ITownItem {
  label: string;
  value: string;
  context?: Comune;
}

/**
 * Parsa e mappa la lista delle province/città in un formato ad uso interno all'applicativo,
 * valido sia da utilizzare nelle select sia come dati da inviare al server.
 */
export function mapProvinceList(list: ComuniResponse | undefined) {
  if (!list) return { provinces: [], towns: [] };
  const provinces: IProvinceItem[] =
    list.province
      ?.map(p => ({
        label: `${p.nome} (${p.codiceBelfiore})`,
        value: p.codiceBelfiore ?? '<unknown>',
        context: p,
      }))
      .sort((a, b) => a.label.localeCompare(b.label)) ?? [];

  const towns: ITownItem[] =
    list.comuni
      ?.map(t => ({
        label: `${t.nome}`,
        value: t.codiceBelfiore ?? '<unknown>',
        context: t,
      }))
      .sort((a, b) => a.label.localeCompare(b.label)) ?? [];

  return {
    provinces,
    towns,
  };
}

export type IProvinceListOptions = ReturnType<typeof mapProvinceList>;
